import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import ProductVariationsProp from '../propTypes/productVariationsProp';
import translate from '../../../commonComponents/translate';
import ShopProductVariationPriceDisplay from './ShopProductVariationPriceDisplay';
import { promotionEndingMessage } from '../../../services/utilityFunctions';
import ShopProductVariationQuantity from './ShopProductVariationQuantity';
import LoggedUserContext from '../../../contextProviders/LoggedUserContext';

function ShopProductVariation({
  t,
  index,
  variation,
  changeProductQuantity,
  productItems,
  stockManagementMessage,
}) {
  const { loggedUser } = useContext(LoggedUserContext);
  const currentVariation = productItems.find(p => p.id === variation._id);

  const [stockChosen, setStockChosen] = useState(0);
  const [isTouched, setIsTouched] = useState(false);
  const getInputQuantityValue = event => {
    const value = parseInt(event.target.value, 10);
    setStockChosen(value);
  };
  const handleChangeMobile = type => {
    setIsTouched(true);
    const unityToChange = type === 'plus' ? 1 : -1;
    const event = {
      target: {
        value: (currentVariation?.amount || 0) + unityToChange,
        id: currentVariation.id,
      },
    };
    changeProductQuantity(event);
    getInputQuantityValue(event);
  };

  const variationIcon = variation.icon ? variation.icon.thumb : '';
  const isPromoStarted = useMemo(
    () =>
      variation?.promotionPriceDateStart
        ? variation.promotionPriceDateStart < moment().utc().valueOf() &&
          loggedUser.type !== 'collaborator'
        : true,
    [variation?.promotionPriceDateStart],
  );
  return (
    <div className="product-info-item variation col-12">
      <div className="product-info-wrapper">
        <div className="product-info-image">
          <img src={variationIcon} alt={variation.name} />
        </div>
        <div className="product-info-price">
          <div className="product-info-type correction-height">
            <span data-testid={`variation-name-${index}`}>
              {variation.name}
            </span>
          </div>
          <div className="product-price-qty">
            <div className="correction-height mobile-variation-price">
              <h4 data-testid={`variation-price-${index}`}>
                <ShopProductVariationPriceDisplay
                  t={t}
                  userPromotionsPrice={variation.userPromotionPrice}
                  userPrice={variation.userPrice}
                />
              </h4>
            </div>
          </div>
        </div>
        <ShopProductVariationQuantity
          t={t}
          index={index}
          handleChange={handleChangeMobile}
          variation={variation}
          currentVariation={currentVariation}
          isTouched={isTouched}
        />
      </div>
      <div className="productRedTextInfo">
        <div className="variation-promotionEnding">
          {isPromoStarted &&
            promotionEndingMessage(
              variation.promotionPriceDateEnd,
              'product.promotion.days.2',
            )}
        </div>
        <div data-testid={`variation-stock-${index}`}>
          {stockManagementMessage(variation, stockChosen)}
        </div>
      </div>
    </div>
  );
}

ShopProductVariation.propTypes = {
  t: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  changeProductQuantity: PropTypes.func.isRequired,
  variation: PropTypes.shape(ProductVariationsProp.propType).isRequired,
  productItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      amount: PropTypes.number,
      price: PropTypes.number,
      va: PropTypes.number,
      commissionable: PropTypes.bool,
    }),
  ).isRequired,
  stockManagementMessage: PropTypes.func.isRequired,
};

export default translate(ShopProductVariation);
